<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div class="cover">
    <div
      v-move="{
        pos: props[item.posKey],
        change: (left:number, top:number) => onPosChange(item.posKey, left, top)
      }"
      v-input="{
        value: props[item.valueKey],
        change: (value:string) => onValueChange(item.valueKey, value)
      }"
      v-for="(item, index) in info"
      :data-edit="useEdit"
      :key="index"
      :class="{ [item.className]: true }"
      v-html="props[item.valueKey]"
    ></div>
    <div v-html="svg" class="svg"></div>
  </div>
</template>

<script setup lang="tsx">
import { vMove, vInput, useCover } from './index';
type Pos = { left: number; top: number; center?: boolean; initHeight?: number };
const props = withDefaults(
  defineProps<{
    useEdit?: boolean;
    projectName: string;
    time: string;
    mainPageEnterpriseName: string;
    titlePosition: Pos;
    settleTimePosition: Pos;
    aspNamePosition: Pos;
    orderNumber: string | number;
    orderNumberPostion: Pos;
  }>(),
  {}
);

const svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1193.368 729.169">
  <path d="M-15270-13420l598.81,366.106,594.559-397.177v354.063l-594.559,375.106-598.81-375.106Z" transform="translate(15270 13451.07)" fill="var(--theme-color-1)"/>
</svg>
`;

const emits = defineEmits(['posChange', 'valueChange']);
const { info, onPosChange, onValueChange } = useCover(emits);
</script>
<style lang="scss" scoped>
.cover {
  background-image: url('https://cdn.yxvzb.com/WEB/SaaS/bi-v3/images/coever-3-templ.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 0 250px;
  height: calc(var(--page-v3-height, 100%) - 2px);
  position: relative;
}
.svg {
  width: 100%;
  position: absolute;
  left: 0;
  top: 390px;
}

.project-name,
.time,
.order-number,
.enterprise-name {
  position: absolute;
  z-index: 2;
  user-select: none;
  text-align: center;
}
.project-name,
.time {
  max-width: 690px;
  font-size: 63px;
  font-weight: 600;
  color: #404040;
}

.project-name {
  min-width: 900px;
}
.time {
  font-size: 36px;
  min-width: 250px;
}
.enterprise-name {
  font-size: 32px;
  font-weight: 500;
  color: #404040;
  min-width: 450px;
  max-width: 80%;
}
.order-number {
  font-size: 46px;
  font-weight: 500;
  color: #484848;
  font-family: PingFang SC;
  font-weight: 600;
}
</style>
